export default __webpack_public_path__ + "static/media/diamond.6fd5553a.svg";